// extracted by mini-css-extract-plugin
export default {"marginTop":"AllProductsLoadingError_marginTop__lPtJ9","errorBox":"AllProductsLoadingError_errorBox__t6ert","link":"AllProductsLoadingError_link__ZlPaa"};